import $ from "jquery";
import * as Cookies from "js-cookie";

const transitionClass = "popup-slided";
const closed = "closed";

$(document).ready(function () {
  const closePopupButton = $("#popup-close");
  const popupElement = $("#page-popup");

  if (popupElement == null) {
    return;
  }

  const popupId = popupElement.data("popup-id");

  closePopupButton.click(closePopup);

  if (!popupIsClosed()) {
    const popupDelay: number = popupElement?.data("popup-delay") ?? 0;
    showPopupInSeconds(popupDelay);
  }

  $(window).scroll(function () {
    if (!popupIsClosed() && $(window).scrollTop() == $(document).height() - $(window).height()) {
      showPopup();
    }
  });

  function showPopupInSeconds(seconds: number): void {
    setTimeout(() => {
      showPopup();
    }, seconds * 1000);
  }

  function showPopup(): void {
    popupElement?.addClass(transitionClass);
  }

  function closePopup(): void {
    popupElement?.addClass("d-none");
    Cookies.set(`popup-${popupId}`, closed);
  }

  function popupIsClosed(): boolean {
    return Cookies.get(`popup-${popupId}`) == closed;
  }
});
